export default {
  SET_DIFF_SERVER_TIME: (state, eventTime) => {
    state.diffServerTime = Date.now() - new Date(eventTime).getTime()
  },
  SET_SERVER_TIME: (state) => {
    state.serverTime += Date.now() + state.diffServerTime
  },
  SET_OPEN_ROLLBOOK: (state) => {
    state.isOpenRollBook = !state.isOpenRollBook
  },
  SET_OPEN_VOICEREQUEST: (state) => {
      state.isOpenVoiceRequest = !state.isOpenVoiceRequest
  },
  SET_OPEN_CONTROL_MENU: (state) => {
    state.isOpenControlMenu = true
  },
  SET_TOGGLE_CONTROL_MENU: (state) => {
    state.isOpenControlMenu = !state.isOpenControlMenu
  },
  SET_CLOSE_CONTROL_MENU: (state) => {
    state.isOpenControlMenu = false
  }
}
